/**
 * @generated SignedSource<<16029f4405115ae55eee3696495e2541>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GlobalDiscountStatus = "ACTIVE" | "NONE" | "SCHEDULED";
export type SetGlobalDiscountCodeIdInput = {
  clientMutationId?: string | null;
  discountCodeId?: string | null;
  startDate?: string | null;
};
export type settingsScreen_SetGlobalDiscountCodeMutation$variables = {
  input: SetGlobalDiscountCodeIdInput;
};
export type settingsScreen_SetGlobalDiscountCodeMutation$data = {
  readonly Admin: {
    readonly Settings: {
      readonly setGlobalDiscountCodeId: {
        readonly clientMutationId: string | null;
        readonly settings: {
          readonly globalDiscountCode: {
            readonly code: string;
            readonly id: string;
          } | null;
          readonly globalDiscountStartDate: string | null;
          readonly globalDiscountStatus: GlobalDiscountStatus;
          readonly id: string;
        };
      } | null;
    };
  };
};
export type settingsScreen_SetGlobalDiscountCodeMutation = {
  response: settingsScreen_SetGlobalDiscountCodeMutation$data;
  variables: settingsScreen_SetGlobalDiscountCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SettingsAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "SetGlobalDiscountCodeIdPayload",
            "kind": "LinkedField",
            "name": "setGlobalDiscountCodeId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Settings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DiscountCode",
                    "kind": "LinkedField",
                    "name": "globalDiscountCode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "globalDiscountStartDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "globalDiscountStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "settingsScreen_SetGlobalDiscountCodeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "settingsScreen_SetGlobalDiscountCodeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f9d6529d2e34a035e6cc8730d0cf679c",
    "id": null,
    "metadata": {},
    "name": "settingsScreen_SetGlobalDiscountCodeMutation",
    "operationKind": "mutation",
    "text": "mutation settingsScreen_SetGlobalDiscountCodeMutation(\n  $input: SetGlobalDiscountCodeIdInput!\n) {\n  Admin {\n    Settings {\n      setGlobalDiscountCodeId(input: $input) {\n        settings {\n          id\n          globalDiscountCode {\n            id\n            code\n          }\n          globalDiscountStartDate\n          globalDiscountStatus\n        }\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aa85ec1d12b47df7a71bd99b1aa513a";

export default node;
